<template>
  <div class="home">
    <div class="tableau">
      <h1
        v-prlx="{
          mobileMaxWidth: 300,
          speed: 0.65,
          preserveInitialPosition: true,
          fromBottom: false,
        }"
      >
        Emanuele Viscuso
      </h1>

      <img
        v-prlx="{
          mobileMaxWidth: 300,
          speed: 0.5,
          reverse: true,
          fromBottom: true,
          preserveInitialPosition: false,
        }"
        class="skyline"
        src="sculptures_photos/sculptures_wood/data/images/10952_232860817176_668452176_4707344_3102935_n.jpg"
      />
      <img
        v-prlx="{
          mobileMaxWidth: 300,
          speed: 1.3,
          reverse: true,
          fromBottom: true,
          preserveInitialPosition: false,
        }"
        class="blimp"
        src="trompe_articles/casa4.jpg"
      />
      <img
        v-prlx="{
          mobileMaxWidth: 300,
          speed: 0.3,
          reverse: true,
          fromBottom: true,
          preserveInitialPosition: false,
        }"
        class="gherkin"
        src="sculptures_photos\staples/10952_231419587176_668452176_4691826_576433_n.jpg"
      />
      <img
        v-prlx="{
          mobileMaxWidth: 300,
          speed: 1.6,
          reverse: true,
          fromBottom: true,
          preserveInitialPosition: false,
        }"
        class="dino"
        src="images2/Edera_Ivy.jpg"
      />

      <img
        v-prlx="{
          mobileMaxWidth: 300,
          speed: 0.2,
          reverse: true,
          fromBottom: true,
          preserveInitialPosition: false,
        }"
        class="bull"
        src="sculptures_photos\fiberglass/10952_230642387176_668452176_4681287_2761960_n.jpg"
      />
    </div>
    <div class="container is-fluid">
      <div class="columns">
        <div class="column" style="min-height: 1250px">
          <img
            src="photos/emanuele_viscuso.jpg"
            alt="Emanuele Viscuso"
            align="right"
            style="margin: 50px 20px"
          /><br />
          <img
            class="bigimage"
            src="images2/casavivapagina4.jpg"
            alt="Emanuele Viscuso"
            align="left"
            contain
            style="margin: 200px -20px"
          /><br />
          <img
            v-prlx="{
              mobileMaxWidth: 200,
              speed: 0.4,
              fromBottom: true,
              preserveInitialPosition: true,
            }"
            class="midimage"
            src="sculptures_photos\twin_towers\10952_231405507176_668452176_4691655_234716_n.jpg"
            alt="Emanuele Viscuso"
            align="right"
            contain
            style="margin: 100px 10px"
          /><br />
          <img
            class="bigimage"
            src="images2/LogoViscuso0030.jpg"
            alt="Emanuele Viscuso"
            align="left"
            contain
            style="margin: -180px -20px"
          /><br />
          <img
            class="bigimage"
            src="sculptures_photos/urban/10952_230657492176_668452176_4681611_7981919_n.jpg"
            alt="Emanuele Viscuso"
            align="left"
            contain
            style="margin: 200px -20px"
          /><br />
        </div>
        <div class="column" style="font-family: Helvetica">
          <section id="about-anchor" ref="about-anchor" class="hero">
            <div class="hero-body">
              <p class="title has-text-white">About</p>
              <p class="subtitle has-text-white">Emanuele Viscuso</p>
            </div>
          </section>
          <h2 class="abouttext">
            Emanuele Viscuso, (born 24 December Palermo, Italy) is a
            <router-link class="link" :to="{ name: 'Sculptures' }"
              >sculptor</router-link
            >, a
            <router-link class="link" :to="{ name: 'Music' }"
              >musician</router-link
            >, a
            <router-link class="link" :to="{ name: 'TrompeLoeil' }"
              >designer</router-link
            >
            and a
            <router-link class="link" :to="{ name: 'Stories' }"
              >cultural promoter</router-link
            >. <br /><br />
            Because of his vast professional trajectory his work can be seen in
            <router-link class="link" :to="{ name: 'Sculptures' }"
              >airports, museums, hotels, banks and private
              collections</router-link
            >, besides continuous exhibitions in Europe and USA. His work has
            been and still is published in numerous
            <router-link class="link" :to="{ name: 'SculpturesArticles' }"
              >books and art magazines</router-link
            >. His international recognition allows him to spend part of the
            year in Mexico, Puerto Escondido. Pierre Restany, famous French art
            critic, defines his work:
            <p>
              The 4th dimension of Emanuele Viscuso is the free territory of all
              the dreams of human beauty, elegance in proportions, dignity in
              spiritual perspectives. The sculptures of Viscuso have in common
              with music this melange inspired by the heart and by the mind, by
              sensitivity and by the spirit: it is the open city of our future
              human becoming.
            </p>
            The base elements of Viscuso's sculptural compositions are in
            modules. He works in wood, steel and fiberglass. Based on the
            mathematics and golden section, this artwork has the same sense of
            harmony present in the public architecture and sculpture of classic
            Greece.

            <br /><br />His most famous piece is the 45-foot-large sculpture
            <router-link class="link" :to="{ name: 'Sculptures' }"
              >"Wave-bridge on the imaginary"</router-link
            >
            located at the Milan Malpensa Internationa Airport. In 2006 Viscuso
            created in Miami the
            <router-link class="link" :to="{ name: 'Stories' }"
              >Sicilian Film Festival</router-link
            >, a showcase of Sicilian directors and movies. In 2008 Viscuso
            created in Castelbuono, Sicily,
            <router-link class="link" :to="{ name: 'Stories' }"
              >F.I.M.O.</router-link
            >
            International Organ Music Festival in the Churches of the Historical
            Princedom of Castelbuono. In 2007 Emanuele Viscuso has taken part to
            <router-link class="link" :to="{ name: 'Stories' }"
              >the STS-120/10A Mission</router-link
            >
            , launched on 23 October 2007 from the NASA's Kennedy Space Centre,
            as delegate in Florida of Accademia Italiana della Cucina, a
            Cultural Institution of the Italian Republic. Thanks to his proposal
            and support, onboard the Space Shuttle Discovery, Node 2, the
            Italian Paolo Nespoli and other astronauts started their journey
            towards the International Space Station (ISS) bringing with them
            delicious Italian food to offer to the other astronauts on the
            Station in orbit. This was the first official Italian dinner in
            space in the history. The Accademia awarded Emanuele Viscuso for
            this remarcable work with the Ettore Pepe Award in Palermo, Sicily
            on September 8,2008. The city of Miami Beach, where he resides since
            November 2000, recognized his cultural involvement in the community
            with the "Key to the City" on 17 October 2007.
            <br /><br />
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VuePrlx from "vue-prlx";
Vue.use(VuePrlx);

export default {
  name: "Home",
  components: {},
  data() {
    return {
      wheight: window.innerHeight,
      hash: this.$route.hash,
    };
  },
  mounted() {
    this.$nextTick(function () {
      if (this.hash) {
        const refName = this.hash.replace("#", "");
        setTimeout(() => {
          this.scrollToAnchorPoint(refName);
        }, 100);
      }
    });
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName];
      el.scrollIntoView({ behavior: "smooth" });
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
a {
  color: #9dc7de;
}
a:hover {
  color: #e48353;
}
.bigimage {
  width: 60%;
}

.midimage {
  width: 40%;
}

.abouttext {
  font-family: "helvetica";
  font-size: 1.8em;
  text-align: justify;
}

h1 {
  margin-top: 2rem;
  z-index: 10;
  position: absolute;
}

.skyline {
  max-height: 500px;
  max-width: 500px;
  top: 50%;
  left: 10%;
  z-index: 5;
  position: relative;
}

.blimp {
  max-height: 500px;
  max-width: 500px;
  top: 63%;
  left: 5%;
  z-index: 8;
  position: relative;
}

.gherkin {
  max-height: 500px;
  max-width: 500px;
  top: 40%;
  z-index: 16;
  position: relative;
}

.dino {
  max-height: 500px;
  max-width: 500px;
  top: 64%;
  left: -5%;
  z-index: 7;
  position: relative;
}

.bull {
  max-height: 500px;
  max-width: 500px;
  top: 40%;
  left: -10%;
  z-index: 5;
  position: relative;
}

.home {
  background-color: #040303;
  background-attachment: fixed;
  background-size: cover;
  font-family: sans-serif;
  font-weight: 300;
  line-height: 1.5;
  color: #fff;
}

h1 {
  width: 100%;
  font: 4em/1 "Oswald", sans-serif;
  text-align: center;
  text-transform: uppercase;
  text-shadow: 3px 3px 20px rgba(0, 0, 0, 0.5);
}

.tableau {
  height: 1000px;
}

p {
  margin: 0 0 1.5em;
}

p:last-child {
  margin-bottom: 0;
}

img {
  width: 20%;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.4);
}

.blog-card-wrap {
  h3 {
    font-weight: 300;
    font-size: 28px;
    margin-bottom: 32px;
  }
}

.updates {
  .container {
    padding: 100px 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media (min-width: 800px) {
      padding: 125px 25px;
      flex-direction: row;
    }

    .router-button {
      display: flex;
      font-size: 14px;
      text-decoration: none;
      @media (min-width: 800px) {
        margin-left: auto;
      }
    }

    h2 {
      font-weight: 300;
      font-size: 32px;
      max-width: 425px;
      width: 100%;
      text-align: center;
      text-transform: uppercase;
      @media (min-width: 800px) {
        text-align: initial;
        font-size: 40px;
      }
    }
  }
}
</style>
